
export const tiposColetaAltura = {
  Todos: "Todos",
  Entrada: "Entrada",
  Afericao: "Aferição",
  Saida: "Saída",
};

export const idsTiposColetaAltura = {
  [tiposColetaAltura.Entrada]: 1,
  [tiposColetaAltura.Afericao]: 2,
  [tiposColetaAltura.Saida]: 3,
};

export const getValueByType = (t, tipo) => {
  switch (tipo) {
    case tiposColetaAltura.Entrada:
      return t("statusIndicator:entry");
    case tiposColetaAltura.Afericao:
      return t("statusIndicator:measurement");
    case tiposColetaAltura.Saida:
      return t("statusIndicator:exit");
    default:
      return t("statusIndicator:all");
  }
}

export const opcoesFarolAltura = (t) => [
  { key: t("statusIndicator:all"), value: tiposColetaAltura.Todos },
  { key: t("statusIndicator:entry"), value: tiposColetaAltura.Entrada },
  { key: t("statusIndicator:measurement"), value: tiposColetaAltura.Afericao },
  { key: t("statusIndicator:exit"), value: tiposColetaAltura.Saida },
];
